import { Button } from '@cleartrip/bento'
import Clevertap from 'analytics'
import FormatCurrency from 'components/FormatCurrency'
import { getflightsHistory } from 'components/ModifySearch/recentSearch'
import { ClevertapDataContext } from 'context/flights/results'
import { ItineraryDataContext, PriceContext } from 'context/itinerary'
import Modal from 'lib/Modal'
import languageTranslate from 'locale'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import { isEmpty } from 'utils/browserHelper'
import { dataLayerGA } from 'utils/dataLayerHelper'

const paxTypeMap = {
    ADT: 'Adults',
    CHD: 'Children',
    INF: 'Infants'
}

export const ItemCard = ({ tripAddData = {}, updatePrice, setSelectedInsuranceDetails, customPayload, showCoupon }) => {
    const [priceSummary] = useContext(PriceContext)
    const [itineraryData] = useContext(ItineraryDataContext)
    const { meta } = itineraryData || {}
    const [clevertapData] = useContext(ClevertapDataContext)
    const [showViewBenefits, setShowViewBenefits] = React.useState(false)
    const location = useLocation()
    let locationArray = location.pathname.split('/')
    let itineraryId = locationArray[locationArray.length - 2]
    const { vasDetails = [], vasType } = tripAddData || {}
    const vasDetail = vasDetails?.at?.(0) //it's always has only one element
    const {
        text: title = '',
        icon: imageSrc = '',
        description = '',

        shortDescription = '',
        tripPremiumDetails = {
            totalPremiumAmount: 0,
            paxTypePremiumDetails: []
        },
        provider,
        autoSelected = false,
        termsAndConditions = {
            mandatory: true
        }
    } = vasDetail || {}

    const { searchCriteria: { paxInfo = {} } = {} } = priceSummary || {}

    const shouldShowPaxEligibilityNote = useMemo(() => {
        const getEligiblePaxDetailsFromPaxTypeMapKey = key => {
            return tripPremiumDetails?.paxTypePremiumDetails?.find(pax => pax.paxType === key)
        }

        let showNote = false

        const paxTypeMapEntries = Object.entries(paxTypeMap)
        for (const [key, value] of paxTypeMapEntries) {
            const eligiblePaxDetails = getEligiblePaxDetailsFromPaxTypeMapKey(key)

            if (paxInfo[value.toLowerCase()] > 0 && paxInfo[value.toLowerCase()] !== eligiblePaxDetails?.paxCount) {
                showNote = true
                break
            }
        }
        return showNote
    }, [])

    const amount = tripPremiumDetails.totalPremiumAmount

    const tripType = useRef('O')

    //if  meta?.utmSource === 'skyscanner' or showCoupon is false then autoSelected should be false else it should be depend on the autoSelected value
    const finalAutoSelected = meta?.utmSource === 'skyscanner' || !showCoupon ? false : autoSelected
    const [insuranceState, setInsuranceState] = useState(finalAutoSelected)

    const { currencyConversionFactor: { code = '' } = {} } = itineraryData || {}

    const cleverTapPayload = {
        action_value: provider
    }

    //send cleverTap Air_UI_Action event
    const sendCleverTapUIActionEvent = (actionName, payload, autoSelected = 'no') => {
        const fullPayload = {
            ...clevertapData,
            ...payload,
            action_name: actionName,
            action_type: 'BUTTON'
        }
        if (actionName === 'itn_insurance_added') {
            fullPayload.auto_selected = autoSelected
        }

        Clevertap.event('Air_UI_Action', fullPayload)
    }
    //trip-add add/remove handler , whole card is clickable
    const handleAddServiceToggle = e => {
        e?.stopPropagation()

        const isAdded = !insuranceState
        updatePriceState(isAdded)
        const dataLayerGAPayload = {
            ...customPayload,
            add_on_name: vasType,
            trip_type: tripType.current === 'O' ? 'single' : 'round'
        }

        if (isAdded) {
            dataLayerGA(dataLayerGAPayload, 'secure_your_trip_added')
            sendCleverTapUIActionEvent('itn_insurance_added', cleverTapPayload)
        } else {
            sendCleverTapUIActionEvent('itn_insurance_removed', cleverTapPayload)
        }

        if (typeof newrelic == 'object') {
            newrelic.addPageAction('trip add service selection', {
                rootURL: window.location.href,
                domain: window.location.hostname,
                platform: 'DESKTOP',
                itineraryId: itineraryId,
                action: isAdded ? 'ADD' : 'REMOVE',
                service: vasType
            })
        }

        setInsuranceState(isAdded)
    }

    //view benefits click handler
    const handleViewBenefits = e => {
        // console.log('View more clicked')
        e?.stopPropagation()
        setShowViewBenefits(true)
    }

    function updatePriceState(isAdded) {
        const priceObj = {
            [vasType]: isAdded
                ? {
                      amount: amount,
                      label: title
                  }
                : undefined
        }

        updatePrice(priceObj)

        setSelectedInsuranceDetails(prev => ({
            ...prev,
            [vasType]: {
                provider,
                noOfDays: 1,
                isMandatory: termsAndConditions?.mandatory,
                isAdded
            }
        }))
    }

    useEffect(() => {
        updatePriceState(insuranceState)

        let flightHistory = getflightsHistory()
        if (!isEmpty(flightHistory)) {
            tripType.current = flightHistory[0]?.rnd_one
        }
    }, [])

    return (
        <>
            <div
                style={{
                    padding: '16px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: '16px',
                    cursor: 'pointer'
                }}
                className="ba bc-neutral-100 br-12"
                onClick={handleAddServiceToggle}
            >
                <div style={{ flex: 1 }}>
                    <img src={imageSrc} alt="image" style={{ width: '40px', height: '40px' }} />
                </div>
                <div style={{ flex: 10, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <h4 className="fs-4">{languageTranslate(title)}</h4>
                    <p className="fs-2 c-neutral-600">{languageTranslate(shortDescription)}</p>
                    <div className="flex flex-middle" style={{ gap: '8px' }}>
                        <h4 className="fs-3 fw-500">
                            <FormatCurrency currency={code} price={amount} />
                        </h4>
                        <div>
                            <button
                                className="fs-2 fw-500 bn c-pointer c-secondary-500 bg-transparent"
                                onClick={handleViewBenefits}
                            >
                                {languageTranslate('view benefits')}
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ width: '96px' }}>
                        <Button outline={!insuranceState} type={'secondary'} full size="sm">
                            {insuranceState ? languageTranslate('Remove') : languageTranslate('Add')}
                        </Button>
                    </div>
                </div>
            </div>

            {/* view benefits modal */}

            <Modal
                isShowing={showViewBenefits}
                isCross
                overlayClassName={'z-100'}
                overlayStyle={{
                    background: 'rgba(0, 0, 0, 0.5)'
                }}
                onOverlayClick={() => setShowViewBenefits(false)}
            >
                <div
                    onClick={e => e.stopPropagation()}
                    className="bg-white pt-7 pb-7 px-6 br-4  o-hidden flex flex-column"
                    style={{
                        minWidth: '432px',
                        maxWidth: '550px',
                        maxHeight: '90vh',
                        minHeight: '300px',
                        justifyContent: 'space-between',
                        overflowY: 'auto'
                    }}
                >
                    <div>
                        <h2 className="fs-6 pb-5">{languageTranslate(title)}</h2>
                        {/* // the below description string can also be contained html tag so using dangerouslySetInnerHTML */}
                        <p
                            className="fs-3 c-neutral-600"
                            dangerouslySetInnerHTML={{
                                __html: languageTranslate(description)
                            }}
                        ></p>

                        {shouldShowPaxEligibilityNote && (
                            <p className="fs-3 c-neutral-700 mt-4 fw-500 bg-secondary-100 br-4 px-4 py-2">
                                {languageTranslate(' Note: This service applicable for')}{' '}
                                {tripPremiumDetails?.paxTypePremiumDetails?.map((pax, index) => {
                                    const { paxType = '' } = pax || {}
                                    return (
                                        <span key={index} className="fs-3 c-neutral-700 mt-4 fw-500">
                                            {languageTranslate(
                                                `${paxTypeMap[paxType]} ${
                                                    index !== tripPremiumDetails?.paxTypePremiumDetails?.length - 1
                                                        ? ', '
                                                        : ''
                                                }`
                                            )}
                                        </span>
                                    )
                                })}
                            </p>
                        )}
                        {/* <p className="fs-3 c-neutral-600">{languageTranslate(description)}</p> */}
                        {/* showing benefits as list */}
                        {/* {!!benefits?.length && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px' }}>
                                {Children.toArray(
                                    benefits?.map(benefit => (
                                        <div className="flex flex-middle">
                                            <div className="mr-4">
                                                <CheckCircle />
                                            </div>
                                            <p className="fs-3 c-neutral-600">{languageTranslate(benefit)}</p>
                                        </div>
                                    ))
                                )}
                            </div>
                        )} */}
                    </div>

                    <div className="flex mt-4 mb-4" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <p className="fs-4 fw-500">
                            <FormatCurrency currency={code} price={amount} />
                        </p>

                        <div style={{ width: '96px' }}>
                            <Button
                                outline={!insuranceState}
                                type={'secondary'}
                                full
                                size="sm"
                                onClick={() => {
                                    handleAddServiceToggle()
                                    setShowViewBenefits(false)
                                }}
                            >
                                {insuranceState ? languageTranslate('Remove') : languageTranslate('Add')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
